<div class="row">
  <div class="col-12 text-end mt-3">
    <ng-container *ngIf="!isFirst">
      <button *ngIf="!customPrevious; else customPreviousButton" class="me-2" mat-raised-button matStepperPrevious>
        {{ "components.stepper.previous-button-label" | translate }}
      </button>
      <ng-template #customPreviousButton>
        <button class="me-2" mat-raised-button (click)="onPrevious()">
          {{ "components.stepper.previous-button-label" | translate }}
        </button>
      </ng-template>
    </ng-container>
    <button
      *ngIf="isLast; else notLast"
      mat-raised-button
      color="primary"
      (click)="onConfirm()"
      [disabled]="stepControl.invalid"
    >
      {{ "components.stepper.confirm-button-label" | translate }}
    </button>
    <ng-template #notLast>
      <button
        mat-raised-button
        color="primary"
        matStepperNext
        (click)="onNextClick()"
        [disabled]="stepControl.invalid"
      >
        {{ "components.stepper.next-button-label" | translate }}
      </button>
    </ng-template>
  </div>
</div>
